function verifyPdf(pdfToVerify) {
  if (pdfToVerify.type !== "application/pdf") {
    return { response: false, message: `Mauvais format de fichier` };
  }
  return true;
}

export default verifyPdf;
